import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './addPatientManually.module.scss';
import { ApiCore } from '../../../api/index';
import { ImageUploader, Picker, Toast, Mask } from 'antd-mobile-v5';
import { ImageUploadItem } from 'antd-mobile-v5/es/components/image-uploader'
import OSS from "ali-oss";
import CRFComponent from '../../../component/crf/crf';
import ArrowRight from '../../static/images/rightArrow.png';
const api = new ApiCore();

let submitFlag = true;

function AddPatientManually(props: any) {

    const [ossData, setOssData] = useState<any>({});// 获取OSS访问令牌
    const [fileList, setFileList] = useState<ImageUploadItem[]>([]) //知情同意书文件列表
    const [groupColumns, setGroupColumns] = useState([]) //患者分组列表
    const [groupList, setGroupList] = useState([]) //患者分组列表总数据
    const [selectListGroup, setSelectListGroup] = useState<any>({}) //患者分组列表总数据
    const [selectGroup, setSelectGroup] = useState<any>(null)  //患者所选分组

    const [groupNodeList, setGroupNodeList] = useState([]) //分组方案节点选择数据
    const [groupNodeColumns, setGroupNodeColumns] = useState([]) //分组方案节点选择展示列表
    const [selectExactGroupNode, setSelectExactGroupNode] = useState<any>({}) //分组方案节点选择选中条目总数据
    const [selectDisplayGroupNode, setSelectDisplayGroupNode] = useState<any>({})  //分组方案节点选择选中展示条目
    const [nodeOnce, setNodeOnce] = useState<Boolean>(false);//只用获取一次随访节点下拉框

    const [visible, setVisible] = useState(false)

    const [formData, setFormData] = useState<any>(null)

    const [taskCode, setTaskCode] = useState('')
    const [caseCode, setCaseCode] = useState('')

    const [npop, setNpOp] = useState('')

    const history: any = useHistory();
    const CrfRef: any = useRef()

    useEffect(() => {
        document.title = '添加患者';
        getOssData();
        getGroup();
        return () => {
            submitFlag = true;
        }
    }, [])

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })
        return newJson
    }

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    };

    const getGroup = () => {
        api.getGroupSelfSelect().then((res: any) => {
            if (res.code === 0) {
                let groupColumns = res.data.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.code
                    }
                })
                setGroupColumns(groupColumns)
                setGroupList(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    // 分组方案节点选择
    const getNodeSelect = (groupCode: '') => {
        if (nodeOnce) {
            return;
        }
        api.getGroupVisitNodeSelect({
            groupCode
        }).then((res: any) => {
            if (res.code === 0) {
                let groupColumns = res.data.map((item: any) => {
                    return {
                        label: item.name,
                        value: item.code
                    }
                })
                setGroupNodeColumns(groupColumns)
                setGroupNodeList(res.data)
            } else {
                Toast.show({
                    content: res.message
                })
            }
            setNodeOnce(true);
        })
    }

    const uploadImage = (file: File): any => {
        return new Promise((resolve, reject) => {
            let client = new OSS({ ...filterPathPre(ossData, 'image') });
            let tenantCode = localStorage.getItem('tenantCode')
            let accountInf = localStorage.getItem('accountInf')
            let accounData = accountInf ? JSON.parse(accountInf) : {}

            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}${tenantCode}/${accounData.account}/${time}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    resolve({ url: res.url });
                }).catch((err: any) => {
                    console.log(err);
                    Toast.show('上传失败请重试');
                })

            }
        })
    }


    const submit = () => {
        if (!selectGroup) {
            Toast.show({
                content: '请选择患者分组',
                duration: 1000
            })
            return false
        }
        if (selectListGroup && selectListGroup.enablePatientLabel && !npop) {
            Toast.show({
                content: '请选择您添加的患者类型',
                duration: 1000
            })
            return false
        }
        if (fileList.length === 0) {
            Toast.show({
                content: '请上传知情同意书',
                duration: 1000
            })
            return false
        }
        let informedConsentForm = fileList.map((obj) => {
            return obj.url;
        }).join(",");

        let params: any = {
            groupCode: selectGroup.value,
            informedConsentForm: informedConsentForm
        }
        if (selectListGroup && selectListGroup.enablePatientLabel) {
            params.label = npop;
        }
        if (selectExactGroupNode && selectExactGroupNode.code && npop === 'OP') {
            params.startNode = selectExactGroupNode.code;
        }
        api.preCreatePatient(params).then((res: any) => {
            if (res.code === 0) {
                let formData = {
                    caseCode: res.data.caseCode,
                    userCode: res.data.patientCode,
                    crfVersion: res.data.fileEvent.tasks[0].formVersion,
                    crfCode: res.data.fileEvent.tasks[0].formCode,
                    recordCode: res.data.fileEvent.tasks[0].code,
                    tenantCode: localStorage.getItem('tenantCode'),
                    channel: "EDC"
                }
                setFormData(formData)
                setTaskCode(res.data.fileEvent.tasks[0].code)
                setCaseCode(res.data.caseCode)
                setVisible(true)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    /**
     * 保存表单内容
     */
    const handleSave = () => {
        CrfRef.current.handleSave()
    }


    /**
    * 表单内容保存成功的回调
    * @param formData 
    */
    const onSaveSuccess = (formData: any) => {
        let formDatas: any = {};
        formData.values.forEach((v: any) => {
            formDatas[v.dataCode] = v.value
        })
        let params = {
            taskCode: taskCode,
            formDatas
        }
        submitFlag && api.finishTask(params).then((res: any) => {
            if (res.code === 0) {
                Toast.show({
                    icon: 'success',
                    content: '保存成功',
                    duration: 1000
                })
                history.replace(`/crf?caseCode=${caseCode}&urlType=patientHome`)
            } else {
                submitFlag = true;
                Toast.show({
                    content: res.message
                })
            }
        })
        submitFlag = false;

    }



    return (
        <div className={styles.manuallyContainer}>

            <div className={styles.firstContent}>
                <div className={styles.contentTitle}>
                    <div>选择患者分组和上传患者知情同意</div>
                    <div className={styles.progress}><span className={styles.current}>1</span>/2</div>
                </div>
                <div className={styles.opertionLabel}>
                    选择要添加患者的分组
                </div>
                <div className={styles.patientGroup}>
                    <div>患者分组</div>
                    <div className={styles.selectGroup}>
                        <div
                            className={styles.selectGroup_item}
                            onClick={async () => {
                                const value = await Picker.prompt({
                                    columns: [groupColumns],
                                })
                                let Index = groupColumns.findIndex((v: any) => v.value == value?.toString())
                                if (Index > -1) {
                                    setSelectGroup(groupColumns[Index])
                                    setSelectListGroup(groupList[Index])
                                }
                            }}
                        >
                            {selectGroup ? selectGroup.label : '请选择患者分组'}
                        </div>
                        <div className={styles.item_arrow}> </div>
                    </div>
                </div>

                {
                    selectListGroup && selectListGroup.enablePatientLabel &&
                    <div className={styles.npop_wrap}>
                        <div className={styles.title}>
                            请选择您添加的患者类型
                        </div>
                        <div className={styles.npop}>
                            <div className={`${styles.npopip} ${npop === 'NP' ? styles.npop_active: styles.npop_no_active}`}
                                onClick={() => { setNpOp('NP'); }} >
                                    新患（NP）
                                </div>
                            <div className={`${styles.npopip} ${npop === 'OP' ? styles.npop_active: styles.npop_no_active}`} onClick={() => { setNpOp('OP'); getNodeSelect(selectGroup.value); }} 
                                style={{borderRight: npop !== 'OP' ? 'none' : '', borderLeft: npop !== 'OP' ? 'none' : ''}}
                            >
                                老患（OP）
                            </div>
                            <div className={`${styles.npopip} ${npop === 'IP' ? styles.npop_active: styles.npop_no_active}`} onClick={() => { setNpOp('IP'); }} >潜在患者（IP）</div>
                        </div>
                    </div>
                }
                {
                    npop === 'OP' && 
                    <div className={styles.patientGroup}>
                        <div>请选择患者起始随访节点</div>
                        <div className={styles.selectGroup}>
                            <div
                                className={styles.selectGroup_item}
                                onClick={async () => {
                                    const value = await Picker.prompt({
                                        columns: [groupNodeColumns],
                                    })
                                    let Index = groupNodeColumns.findIndex((v: any) => v.value == value?.toString());
                                    if (Index > -1) {
                                        setSelectDisplayGroupNode(groupNodeColumns[Index])
                                        setSelectExactGroupNode(groupNodeList[Index])
                                    }
                                }}
                            >
                                {selectDisplayGroupNode?.label ? selectDisplayGroupNode.label : '请选择随访节点'}
                            </div>
                            <div className={styles.item_arrow}> </div>
                        </div>
                    </div>
                }

                <div className={styles.opertionLabel}>
                    上传患者知情同意书
                </div>
                <div className={styles.informedConsent}>
                    <div className={styles.topContent}>
                        <span>上传知情同意书</span>
                        {/* <span className={styles.downLoadBtn}>模板下载</span> */}
                    </div>
                    <ImageUploader
                        value={fileList}
                        multiple={true}
                        onChange={setFileList}
                        upload={uploadImage}
                        style={{ '--cell-size': '76px' }}
                    />
                    <div className={styles.tips}>
                        <p>拍照说明：</p>
                        <p>请保证上传的知情书内容及患者签名清晰可辨认。</p>
                        <p>照片支持png，jpeg格式。</p>
                    </div>
                </div>
                <div className={styles.actonBtns}>
                    <div className={styles.backBtn} onClick={() => history.goBack()}>返回</div>
                    <div className={styles.nextBtn} onClick={submit}>下一步</div>
                </div>
            </div>


            <Mask
                color='white'
                visible={visible}
                opacity={1}
            >
                <div className={styles.nextCotent1}>
                    <div className={styles.contentTitle}>
                        <div>患者建档信息填写</div>
                        <div className={styles.progress}><span className={styles.current}>2</span>/2</div>
                    </div>
                    <div className={styles.crf_content}>
                        <CRFComponent
                            ref={CrfRef}
                            params={formData}
                            onSaveSuccess={(v: any) => onSaveSuccess(v)}
                        />
                    </div>
                    <div className={styles.actonBtns}>
                        <div className={styles.backBtn} onClick={() => history.goBack()}>返回</div>
                        <div className={styles.nextBtn} onClick={handleSave}>完成</div>
                    </div>
                </div>
            </Mask>
        </div>
    )

}

export default AddPatientManually;